import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from '@angular/material';

import { DataTableModule } from 'primeng/primeng';

import { SharedModule } from 'app/shared/shared.module';

import { BankAccountComponent } from './bankaccount/bank-account.component';
import { EntityFinanceComponent } from './entity-finance.component';
import {AddBankStatementComponent} from './bank-statement/add-bank-statement.component';
import { ViewTransactionComponent } from './view-transaction/view-transaction.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { EditTransactionComponent } from './edit-transaction/edit-transaction.component';
import { BankStatementPreviewComponent } from '../transaction-monitoring/bank-statement-preview/bank-statement-preview.component';
import { ReanalyzeComparisonComponent } from './reanalyze-comparison/reanalyze-comparison.component';
import { DuplicateDocumentWarningComponent } from './duplicate-document-warning/duplicate-document-warning.component';
import { MoveBankStatementDialogComponent } from './move-bank-statement-dialog/move-bank-statement-dialog.component';

@NgModule({
    declarations: [
        BankAccountComponent,
        EntityFinanceComponent,
        AddBankStatementComponent,
        ViewTransactionComponent,
        ConfirmDialogComponent,
        EditTransactionComponent,
        BankStatementPreviewComponent,
        ReanalyzeComparisonComponent,
        DuplicateDocumentWarningComponent,
        MoveBankStatementDialogComponent
    ],
    imports: [
        SharedModule,
        MaterialModule.forRoot(),
        ReactiveFormsModule,
        BrowserModule,
        FormsModule,
        FlexLayoutModule,
        DataTableModule,
    ],
    providers: [],
    entryComponents: [
        BankAccountComponent,
        AddBankStatementComponent,
        ViewTransactionComponent,
        ConfirmDialogComponent,
        EditTransactionComponent,
        BankStatementPreviewComponent,
        ReanalyzeComparisonComponent,
        DuplicateDocumentWarningComponent,
        MoveBankStatementDialogComponent
    ],
    exports: [
        BankAccountComponent
    ]
})

/**
 * Main module for the entity finance tab management.
*/
export class EntityFinanceModule { }



// WEBPACK FOOTER //
// ./src/app/entities/finance/entity-finance.module.ts